import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReportIcon from "@mui/icons-material/Assignment";
import SummarizeIcon from '@mui/icons-material/Summarize';
import BalanceIcon from '@mui/icons-material/Balance';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MedicationIcon from '@mui/icons-material/Medication';
import CategoryIcon from '@mui/icons-material/Category';
import FunctionsIcon from '@mui/icons-material/Functions';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ScienceIcon from '@mui/icons-material/Science';
import HistoryIcon from '@mui/icons-material/History';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import TuneIcon from '@mui/icons-material/Tune';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import BiotechIcon from '@mui/icons-material/Biotech';
import InputIcon from '@mui/icons-material/Input';
import OutputIcon from '@mui/icons-material/Output';
import LayersIcon from '@mui/icons-material/Layers';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SensorsIcon from '@mui/icons-material/Sensors';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import RouteIcon from '@mui/icons-material/Route';
import InventoryIcon from '@mui/icons-material/Inventory';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import DifferenceIcon from '@mui/icons-material/Difference';
import StorefrontIcon from '@mui/icons-material/Storefront';
import KitchenIcon from '@mui/icons-material/Kitchen';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BuildIcon from '@mui/icons-material/Build';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CalculateIcon from '@mui/icons-material/Calculate';
import LabelIcon from '@mui/icons-material/Label';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ColorizeIcon from '@mui/icons-material/Colorize';
import StyleIcon from '@mui/icons-material/Style';
import TerrainIcon from '@mui/icons-material/Terrain';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import ConstructionIcon from '@mui/icons-material/Construction';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import WaterIcon from '@mui/icons-material/Water';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DescriptionIcon from '@mui/icons-material/Description';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import OpacityIcon from '@mui/icons-material/Opacity';
import AttachFileIcon from '@mui/icons-material/AttachFile';


const pages = [
  { label: "Dashboard", route: "dashboard", icon: <DashboardIcon /> },
  {
    label: "Omni Search",
    route: "search-data",
    icon: <ScreenSearchDesktopIcon />,
  },
  {
    label: "Orders",
    icon: <ReceiptLongIcon />,
    subItems: [
      { label: "Lab Orders", route: "lab-orders", icon: <ShoppingCartIcon /> },
      {
        label: "ETK Orders",
        route: "etk-registration-queue",
        icon: <AppRegistrationIcon />,
      },
      { label: "Track Orders", route: "track-lab-orders", icon: <QueryStatsIcon /> },
      { label: "Lab Order Generator", route: "new-order", icon: <AddShoppingCartIcon /> },
    ],
  },
  {
    label: "Analytical",
    icon: <BiotechIcon />,
    subItems: [
      { label: "Micro In", route: "micro-in", icon: <InputIcon /> },
      { label: "Micro Out", route: "micro-out", icon: <OutputIcon /> },
      { label: "Batch Manager", route: "batch-manager", icon: <LayersIcon /> },
      { label: "Search Batch", route: "search-batch", icon: <ContentPasteSearchIcon /> },
      { label: "Outsourced Analysis", route: "outsourced-analysis", icon: <HandshakeIcon /> },

    ],
  },
  {
    label: "Instrument Data",
    icon: <SensorsIcon />,
    subItems: [
      { label: "ELI ICP", route: "coming-soon", icon: <UploadFileIcon /> },
      { label: "ELI ICPMS", route: "eli-icpms", icon: <UploadFileIcon /> },
      { label: "ELI IC", route: "eli-ic", icon: <UploadFileIcon /> },
      { label: "ELI ATI", route: "eli-ati", icon: <UploadFileIcon /> },
      { label: "ELI GCMS", route: "coming-soon", icon: <UploadFileIcon /> },
      { label: "ELI Old BOD", route: "coming-soon", icon: <UploadFileIcon /> },
      { label: "ELI BOD", route: "coming-soon", icon: <UploadFileIcon /> },
    ],
  },
  {
    label: "Billing",
    icon: <MonetizationOnIcon />,
    subItems: [
      { label: "Invoices", route: "invoices", icon: <ReceiptIcon /> },
      { label: "Quotes", route: "quotes", icon: <RequestQuoteIcon /> },
    ],
  },
  {
    label: "Bottle Orders",
    route: "bottle-orders",
    icon: <MedicationIcon />,
  },
  {
    label: "Routes",
    route: "user-routes-admin",
    icon: <RouteIcon />,
  },

  // {
  //   label: "Routes",
  //   icon: <LocalShippingIcon />,
  //   subItems: [
  //     { label: "Manage Routes", route: "user-routes-admin", icon: <NoCrashIcon /> },
  //     { label: "User Routes", route: "user-routes", icon: <DirectionsBikeIcon /> },
  //   ],
  // },
  {
    label: "Quality Control",
    icon: <FactCheckIcon />,
    subItems: [
      { label: "Temperature Tracker", route: "quality-control/temperature-tracker", icon: <DeviceThermostatIcon /> },

    ],
  },

  {
    label: "Inventory",
    icon: <Inventory2Icon />,
    subItems: [
      { label: "Products", route: "inventory-products", icon: <CategoryIcon /> },
      { label: "Supply Orders", route: "inventory-supply-orders", icon: <LocalShippingIcon /> },
      { label: "Test Kits", route: "inventory-test-kits", icon: <HomeRepairServiceIcon /> },
      { label: "Inventory Tracker", route: "inventory-tracker", icon: <InventoryIcon /> },
      { label: "Locations", route: "inventory-locations", icon: <WarehouseIcon /> },
      { label: "Reorder Report", route: "inventory-reorder", icon: <ProductionQuantityLimitsIcon /> },
      { label: "Count Variance", route: "inventory-count-variance", icon: <DifferenceIcon /> },
      { label: "Inventory History", route: "inventory-history", icon: <HistoryIcon /> },
      { label: "Vendors", route: "maintenance-vendor", icon: <StorefrontIcon /> },
      {
        label: "Coolers",
        icon: <AcUnitIcon />,
        subItems: [
          { label: "Coolers", route: "coolers", icon: <KitchenIcon /> },
          { label: "Cooler Profiles", route: "cooler-profiles", icon: <TuneIcon /> },
          { label: "Cooler Shippings", route: "cooler-shippings", icon: <MoveToInboxIcon /> },
        ],
      },
    ],
  },

  {
    label: "Reports",
    icon: <AssessmentIcon />,
    subItems: [
      { label: "Lab", route: "reports-lab", icon: <ReportIcon /> },
      { label: "Admin", route: "reports-admin", icon: <SupervisorAccountIcon /> },
      { label: "Others", route: "reports-others", icon: <SummarizeIcon /> },
      // { label: "ETK Orders", route: "reports-etk-orders", icon: <SummarizeIcon /> },
      { label: "Custom Reports", route: "reports-custom", icon: <DashboardCustomizeIcon /> },
    ],
  },
  {
    label: "Maintenance",
    icon: <BuildIcon />,
    subItems: [
      {
        label: "Test",
        icon: <BalanceIcon />,
        subItems: [
          { label: "Library Management", route: "maintenance-test-library-management", icon: <LibraryBooksIcon /> },
          { label: "Slate Maintenance", route: "maintenance-test-slate", icon: <FormatListBulletedIcon /> },
          { label: "Formulas", route: "maintenance-test-formulas", icon: <CalculateIcon /> },
          { label: "Categories", route: "maintenance-test-categories", icon: <LabelIcon /> },
          { label: "Testing Instruments", route: "maintenance-test-instruments", icon: <PrecisionManufacturingIcon /> },
          { label: "QC Test Types", route: "maintenance-test-qc-test-types", icon: <ChecklistIcon /> },
          { label: "Process Configuration", route: "test-process-configuration", icon: <AccountTreeIcon /> },
        ],
      },
      {
        label: "Sample",
        icon: <ColorizeIcon />,
        subItems: [
          { label: "Types", route: "maintenance-sample-types", icon: <StyleIcon /> },
          { label: "Matrices", route: "maintenance-sample-matrices", icon: <TerrainIcon /> },
          { label: "Bottles", route: "maintenance-sample-bottles", icon: <LocalDrinkIcon /> },
        ],
      },
      {
        label: "Billing",
        icon: <PointOfSaleIcon />,
        subItems: [
          { label: "Miscellaneous Charges", route: "maintenance-billing-misc-charges", icon: <LocalAtmIcon /> },
          { label: "General Ledger", route: "maintenance-billing-general-ledger", icon: <AccountBalanceIcon /> },
        ],
      },
      { label: "Dropdown Lists", route: "maintenance-dropdown-lists", icon: <ListAltIcon /> },
      { label: "Vendor", route: "maintenance-vendor", icon: <StorefrontIcon /> },
      { label: "Client", route: "maintenance-client", icon: <BusinessIcon /> },
      { label: "Equipment Inventory", route: "maintenance-equipment-inventory", icon: <ConstructionIcon /> },
      { label: "Chemical Inventory", route: "maintenance-chemical-inventory", icon: <ScienceIcon /> },
      { label: "ETK Registration Queue", route: "etk-registration-queue", icon: <AppRegistrationIcon /> },
      { label: "Enviro Test Kits", route: "enviro-test-kits", icon: <WaterDropIcon /> },
      { label: "TypeForm Test Kits", route: "test-kits", icon: <DynamicFormIcon /> },
      { label: "Water Profiles", route: "water-profiles", icon: <WaterIcon /> },
      { label: "Outsourced Analysis", route: "outsourced-analysis", icon: <HandshakeIcon /> },
      { label: "Email Templates", route: "email-templates", icon: <MarkEmailUnreadIcon /> },
    ],
  },
  {
    label: "Settings",
    icon: <SettingsIcon />,
    subItems: [
      { label: "System Configuration", route: "settings-system-configuration", icon: <SettingsApplicationsIcon /> },
      { label: "Users", route: "settings-users", icon: <ManageAccountsIcon /> },
      { label: "Reports", route: "settings-reports", icon: <DescriptionIcon /> },
      { label: "Email Accounts", route: "email-accounts", icon: <AlternateEmailIcon /> },
      {
        label: "Audit",
        icon: <ManageHistoryIcon />,
        subItems: [
          { label: "Orders", route: "settings-audit-log/orders", icon: <ShoppingCartCheckoutIcon /> },
          { label: "Samples", route: "settings-audit-log/samples", icon: <OpacityIcon /> },
          { label: "Results", route: "settings-audit-log/results", icon: <FunctionsIcon /> },
        ],
      },
    ],
  },

  {
    label: "Scanner",
    icon: <DocumentScannerIcon />,
    subItems: [
      { label: "Scan", route: "scan", icon: <QrCodeScannerIcon /> },
      { label: "Splitter", route: "splitter", icon: <CallSplitIcon /> },
      { label: "Attach CoC", route: "attach-coc", icon: <AttachFileIcon /> },
    ],
  },

  // {
  //   label: "Old Scanner",
  //   route: "scanner",
  //   icon: <QrCodeScannerIcon />,
  // },
];

export default pages;
